import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useLocalSessionId, useVideoTrack } from '@daily-co/daily-react';
import './SelfView.css';
import Button from '../../primitives/Button/Button';

import { ReactComponent as CloseIcon } from '../../../../assets/icon/close.svg';
import { ReactComponent as ExpandIcon } from '../../../../assets/icon/caret-expand-less.svg';
import { getIsSelfViewEnabled } from '../../../../services/LocalStorage';

const HUDSelfView: React.FC = React.memo(() => {
  const localUserId = useLocalSessionId();
  const localVideo = useVideoTrack(localUserId);
  const [cameraStream, setCameraStream] = useState<MediaStream | null>(null);
  const [isVisible, setIsVisible] = useState(getIsSelfViewEnabled());

  useEffect(() => {
    if (localVideo.persistentTrack) {
      if (cameraStream) cameraStream.getVideoTracks()[0].stop();
      setCameraStream(new MediaStream([localVideo.persistentTrack]));
    }
  }, [localVideo.state]);

  const toggleVisibility = useCallback(() => {
    setIsVisible(!isVisible);
  }, [isVisible]);

  const toggleVisibilityButton = useMemo(() => (
    <Button onClick={toggleVisibility} size="tiny" label="" icon={isVisible ? <CloseIcon /> : <ExpandIcon />} />
  ), [toggleVisibility, isVisible]);

  return (
    <div className="hud-self-root">
      <div className={(isVisible ? "hide" : "show") + " hud-self-button" }>
        { toggleVisibilityButton }
      </div>
      {
        isVisible && 
        <video
          ref={(video) => {
            if (video) {
              video.srcObject = cameraStream;
            }
          }}
          className="hud-self-video"
          autoPlay
          muted
        />
      }
    </div>
  );
});

export default HUDSelfView;
